/** Small client-safe helper; do not pull the database schema into the feed bundle. */
export function extractKudozMultiplier(
  details: { kudozMultiplier?: unknown; kudozBonus?: unknown } | null | undefined
): number | null {
  if (!details) return null;
  if (details.kudozMultiplier !== undefined) {
    const explicit = details.kudozMultiplier;
    return typeof explicit === "number" && Number.isFinite(explicit) && explicit > 1
      ? explicit
      : null;
  }
  return details.kudozBonus === "2x" ? 2 : null;
}